export const QUESTION_LIMIT = 8000;
export const CONTEXT_MESSAGE_LIMIT = 30;
export const MESSAGE_TEXT_LIMIT = 16000;

export const SUGGESTED_QUESTIONS = [
  'What does this product do?',
  'Who is the ideal customer?',
  'What makes it different?',
  'How should I pitch it?',
];

export const DISCARD_COPY = {
  title: 'Discard conversation?',
  body: 'Leaving will discard your current conversation and any unfinished input. This cannot be undone.',
  cancel: 'Cancel',
  confirm: 'Discard and continue',
};

export const hasUnderstandWork = (messages, draft) =>
  (Array.isArray(messages) && messages.length > 0) || String(draft || '').trim().length > 0;

export const conversationPayload = (messages) =>
  (Array.isArray(messages) ? messages : [])
    .filter(
      (message) =>
        message && (message.role === 'user' || message.role === 'assistant') && String(message.text || '').trim(),
    )
    .slice(-CONTEXT_MESSAGE_LIMIT)
    .map((message) => ({
      role: message.role,
      text: String(message.text).trim().slice(0, MESSAGE_TEXT_LIMIT),
    }));
